import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import type { IGetInvoicesFilterParams } from "../getInvoices/getInvoicesRequest.schema";
import type { TGetInvoiceBulkActionCountsResponse } from "./getInvoiceBulkActionCounts.schema";

/**
 * Fetches counts per bulk action for invoices matching the given filter.
 * Used when "select all" is active so the bulk action dialog shows correct
 * totals across all pages.
 */
export const getInvoiceBulkActionCounts =
  (axios: IAxiosInstance) =>
  async (
    companyID: string,
    search: string = "",
    filterParams?: IGetInvoicesFilterParams,
    excludeIds: string[] = []
  ): Promise<TGetInvoiceBulkActionCountsResponse> => {
    const params: Record<string, string | string[]> = {
      companyID,
      search: search ?? "",
    };
    if (filterParams) {
      if (filterParams.status) params.status = filterParams.status;
      if (filterParams.payment_status)
        params.payment_status = filterParams.payment_status;
      if (filterParams.invoiceDateFrom)
        params.invoiceDateFrom = filterParams.invoiceDateFrom;
      if (filterParams.invoiceDateTo)
        params.invoiceDateTo = filterParams.invoiceDateTo;
      if (filterParams.dueDateFrom)
        params.dueDateFrom = filterParams.dueDateFrom;
      if (filterParams.dueDateTo) params.dueDateTo = filterParams.dueDateTo;
    }
    if (excludeIds.length > 0) {
      params.excludeIds = excludeIds;
    }

    const response = await axios.noRetry.get<
      | TGetInvoiceBulkActionCountsResponse
      | {
          data: TGetInvoiceBulkActionCountsResponse;
          success?: boolean;
          testMode?: boolean;
        }
    >("/api/invoices/bulk-action-counts", { params });
    const resData = response.data;
    if (resData && typeof resData === "object" && "error" in resData) {
      throw new Error(
        (resData as { error?: string }).error ??
          "Error fetching bulk action counts"
      );
    }
    const wrapped = resData as { data?: TGetInvoiceBulkActionCountsResponse };
    return (
      wrapped?.data != null ? wrapped.data : resData
    ) as TGetInvoiceBulkActionCountsResponse;
  };
